export default import.meta.ROLLUP_FILE_URL_tgFyw$X211zXSctfMU9_LA;